import React from "react";

import { Link } from "react-router-dom";
import { useTheme } from "../hooks/useTheme";

//SVG's
import Logo from "../svgs/Logo";
import LogoLight from "../svgs/LogoLight";

const LogoMenu = () => {
  const { theme } = useTheme();

  const logo = theme === "dark"
    ? <LogoLight />
    : <Logo />;

  return (
    <Link className="nav-logo" to="/">
      {logo}
    </Link>
  );
}

export default LogoMenu;